<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '~ds/lib/utils'
import { Primitive } from 'reka-ui'

import type { BadgeDotVariants } from '.'

import { badgeDotVariants } from '.'

const props = defineProps<{
  tone?: BadgeDotVariants['tone'];
  class?: HTMLAttributes['class'];
}>()
</script>

<template>
  <Primitive
    as="span"
    data-slot="badge-dot"
    aria-hidden="true"
    :class="cn(badgeDotVariants({ tone }), props.class)"
  />
</template>
